<template>
  <main class="bg-white u-container container">
    <div class="header-wrapper">
      <img
        id="important-notice-icon"
        loading="lazy"
        :src="$options.IconInfoBlue"
        alt="The letter I enclosed in a circle"
        width="32"
        height="32"
      />
      <p class="header">Your Session Reset</p>
    </div>

    <p class="copy">
      To protect your information, this page reset. Please start a new USPS
      Change-of-Address request.
    </p>
    <div class="button-wrapper">
      <button ref="startOver" class="c-btn button" @click="restart">
        Restart My Request
      </button>
    </div>
  </main>
</template>

<script>
import pageView from "../mixins/pageView";
import IconInfoBlue from "../assets/images/_icon_info_blue.svg";

export default {
  name: "ErrorSessionUnavailable",
  mixins: [pageView],
  IconInfoBlue,
  mounted() {
    this.pageView();
  },
  methods: {
    clearRequest() {
      this.$deleteSession();
      this.$resetAppState();
      this.$coa.reset();
    },
    restart() {
      this.clearRequest();
      window.location.replace(window.location.origin);
    },
  },
};
</script>

<style scoped>
.container {
  height: 100vh;
  max-height: 747px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;

  @media only screen and (min-width: 993px) {
    align-items: baseline;
    justify-content: flex-start;
    height: auto;
  }
}

.header-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;

  @media only screen and (min-width: 993px) {
    flex-direction: row;
    gap: 16px;
  }
}

.header {
  font-weight: 700;
  color: #004b87;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: 0;

  @media only screen and (min-width: 993px) {
    font-size: 28px;
    line-height: 34px;
  }
}

.copy {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;

  @media only screen and (min-width: 993px) {
    font-size: 16px;
    line-height: 22px;
    text-align: left;
  }
}

.button-wrapper {
  background-color: #fff;
  width: 100%;
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 993px) {
    width: auto;
    padding: 24px 0 0 0;
    position: relative;
  }
}

.button {
  width: 100%;

  @media only screen and (min-width: 993px) {
    width: 194px;
  }
}
</style>
